//import angular from 'angular';


angular.module('app.admin')
        .service("delayReasonSvc", [
            "amtXlatSvc", "WindowFactory", "exportSvc", "$q", "amtCommandQuerySvc", "ocConfigSvc",
            function ( 
                amtXlatSvc, WindowFactory, exportSvc, $q, amtCommandQuerySvc, ocConfigSvc
            ) {
                var svc = this; 

                svc.module = "DelayReasons";
                svc.resourceGroup = "delayReason";
                svc.mainPermission = 'Security.Settings.Maintenance.' + svc.module;

                svc.showCategory = false;

                svc.addOption = function (arrayName, name, key, def?, active?) {
                    var item = {
                        name: name,
                        key: key,
                        isActive: active !== false
                    };

                    if (!svc[arrayName]) {
                        svc[arrayName] = [];
                    }

                    // add it to the list
                    svc[arrayName].push(item);

                    if (def === true) {
                        if (!svc.defaults) {
                            svc.defaults = {};
                        }

                        if (!svc.defaults[arrayName]) {
                            svc.defaults[arrayName] = [];
                        }

                        svc.defaults[arrayName].push(item);
                    }
                };

                svc.getAsync = function (id) {
                    var criteria = {
                        id: id
                    };

                    return amtCommandQuerySvc.post(svc.urls.get, criteria);
                };

                svc.loadDefaultsAsync = function () {
                    return $q(function (resolve) {

                        svc.activeStates = svc.getActiveStates();

                        if (!svc.categories) {
                            svc.addOption("categories", amtXlatSvc.xlat('delayReason.categoryTyreRelatedWork'), 0, svc.showCategory);
                            svc.addOption("categories", amtXlatSvc.xlat('delayReason.categoryNonTyreRelatedWork'), 1, svc.showCategory);
                            svc.addOption("categories", amtXlatSvc.xlat('delayReason.categoryJobDelayReason'), 2, true);
                        }

                        return resolve(svc.defaults);
                    });
                };

                svc.getActiveStates = function () {
                    return [
                        {
                            key: true,
                            description: amtXlatSvc.xlat('client.activeTrue'),
                            default: true
                        },
                        {
                            key: false,
                            description: amtXlatSvc.xlat('client.activeFalse'),
                            default: false
                        }
                    ];
                };

                svc.openSite = function (site, cb) {
                    WindowFactory.openItem({
                        component: 'add-edit-site',
                        caption: amtXlatSvc.xlat("site.editSite"),
                        initParams: { id: site.id },
                        width: 550,
                        windowRelatedRecordId: site.id
                    });
                };

                svc.webAPIController = "DelayReason";

                svc.urls = {
                    getLookups: baseApiUrl + 'referenceData/getWorkshopSessionTimeTypes',
                    get: svc.webAPIController + '/get',
                    save: svc.webAPIController + '/save',
                    search: baseApiUrl + svc.webAPIController + '/search',
                    export: svc.webAPIController + '/export'
                };

                svc.export = function (searchCriteria) {
                    exportSvc.exportData(svc.urls.export, searchCriteria, amtXlatSvc.xlat(svc.resourceGroup + '.searchTitle'));
                };

                svc.saveAsync = function (item) {
                    var criteria = {
                        id: item.id,
                        mode: item.mode,
                        name: item.name,
                        description: item.description,
                        isActive: item.isActive,
                        languageTypeId: item.languageTypeId,
                        category: item.category,
                        applyToAllLanguages: item.applyToAllLanguages
                    };

                    return amtCommandQuerySvc.post(svc.urls.save, criteria);
                };

                svc.addItem = function (cb) {
                    var item = {
                        isActive: false,
                        applyToAllLanguages: true,
                        category: svc.showCategory === true ? null : 2, // hard-coded to job display reason
                        mode: 'add'
                    };

                    svc.openItem(item, cb);
                };

                svc.openItem = function (item, cb) {
                    WindowFactory.openItem({
                        component: 'add-edit-delay-reason',
                        caption: amtXlatSvc.xlat(svc.resourceGroup + "." + (item.mode === "add" ? "addItem" : "editItem")),
                        initParams: item,
                        width: 550,
                        onDataChangeHandler: cb,
                        windowRelatedRecordId: item.id
                    });
                };

            }
        ]
        )
